module.exports = "<alert></alert>\r\n<div fxFlexFill class=\"full-height full-width\">\r\n  <router-outlet fxFlexFill></router-outlet>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/cmcever/Documents/GitHub/ChallengerTurf/EPSePortal/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main